import { type FC } from "react";

import { ErrorLine } from "@styled/error_line";
import { SetupReviewGroup } from "@styled/setup_review";

import { DraftingFieldRow } from "./drafting_field_row";
import { useDraftingSectionsOf } from "./use_drafting_sections";

// His Word draft's fill-in fields, over Your sections as his header is over
// his report: each one's value on this case, to correct in place.
export const DraftingFieldsGroup: FC = () => {
  const { fields } = useDraftingSectionsOf();
  if (fields.fields.length === 0) return null;

  return (
    <>
      <SetupReviewGroup label="Fields" line={String(fields.fields.length)}>
        {fields.fields.map((field) => (
          <DraftingFieldRow
            key={field.kind}
            field={field}
            onSave={fields.update}
          />
        ))}
      </SetupReviewGroup>
      {fields.error && <ErrorLine>{fields.error}</ErrorLine>}
    </>
  );
};
